var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8182 2.81812V6.45448C12.8182 6.69558 12.914 6.92682 13.0844 7.0973C13.2549 7.26779 13.4862 7.36357 13.7273 7.36357H17.3636",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63637 10.9999V4.6363C4.63637 4.15409 4.82793 3.69162 5.1689 3.35065C5.50988 3.00967 5.97234 2.81812 6.45455 2.81812H12.8182L17.3636 7.36357V10.9999",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63637 16.4546H6C6.36166 16.4546 6.70851 16.3109 6.96424 16.0552C7.21997 15.7994 7.36364 15.4526 7.36364 15.0909C7.36364 14.7293 7.21997 14.3824 6.96424 14.1267C6.70851 13.871 6.36166 13.7273 6 13.7273H4.63637V19.1818",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5455 16.4546H17.3636",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2727 13.7273H15.5455V19.1818",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 13.7273V19.1818H11C11.4822 19.1818 11.9447 18.9903 12.2857 18.6493C12.6266 18.3083 12.8182 17.8459 12.8182 17.3637V15.5455C12.8182 15.0633 12.6266 14.6008 12.2857 14.2598C11.9447 13.9189 11.4822 13.7273 11 13.7273H10.0909Z",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(0.0909119 0.0908203)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.ad5af97ca86f108ad7eeb4cabcedfa7f.svg";
export { ForwardRef as ReactComponent };